import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import MainLayout from "../../Layout/mainLayout";
import { editNews, viewNews } from "../../Redux/Actions/newsAction";
import { useDispatch, useSelector } from "react-redux";
import {
  viewCityList,
  viewCountryListPagination,
  viewStateListPagination,
} from "../../Redux/Actions/settingsActions";
import AddImage from "../../Global Functions/addImage";
import { getProjectList } from "../../Redux/Actions/projectActions";
import { getEnums } from "../../Redux/Actions/enumsActions";
import { viewCategoryList } from "../../Redux/Actions/categoryActions";
import ImageShowerModal from "../../Global Functions/imageShowerModal";
import ImageShowerModalGlobal from "../../Global Functions/imageShowerModalGlobal";
import { DateToNormal } from "../../Utils/helpers";
import toast from "react-hot-toast";
import "./editNews.css";

const EDIT_TITLE_LIMIT = 50;

const EditNews = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [newsData, setNewsData] = useState({
    title: "",
    description: "",
    url: "",
    type: "",
    news_link: "",
    start_date: "",
    end_date: "",
    country: "",
    city: "",
    state: "",
    project: "",
    category: "",
  });

  const [selection, setSelection] = useState("");
  const [activeSection, setActiveSection] = useState(0);
  const [uploading, setUploading] = useState({ image: false, video: false });

  const uploadOptions = ["file", "url"];
  const categoryOptions = ["trending", "what's new", "luxury"];
  const sections = ["Basic Info", "Location & Dates", "Media & Links"];

  const { countryList } = useSelector((state) => state.country || {});
  const { states } = useSelector((state) => state.states || {});
  const { cities } = useSelector((state) => state.city || {});
  const { enumsData } = useSelector((state) => state.enumsData || {});
  const { projects } = useSelector((state) => state.projects || {});
  const { news } = useSelector((state) => state.news || {});

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === "title" && value.length > EDIT_TITLE_LIMIT) return;
    setNewsData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const filteredData = Object.fromEntries(
        Object.entries(newsData).filter(([, value]) => value !== null && value !== undefined && value !== "")
      );
      if (!filteredData.category) return toast.error("Category is required");
      const response = await dispatch(editNews(filteredData, id));
      if (response.statusCode === 200) {
        navigate("/news_and_articles");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };

  const handleFileUpload = async (event) => {
    const uploadedFile = event.target.files[0];
    const inputId = event.target.id;
    if (!uploadedFile) return;
    setUploading((prev) => ({ ...prev, [inputId]: true }));
    const responseUrl = await AddImage(uploadedFile);
    setUploading((prev) => ({ ...prev, [inputId]: false }));
    if (responseUrl) {
      setNewsData((prev) => ({
        ...prev,
        url: responseUrl,
        type: inputId === "image" ? "image" : "video",
      }));
    }
  };

  useEffect(() => {
    dispatch(viewNews(id));
    dispatch(viewCountryListPagination());
    dispatch(getEnums());
    dispatch(viewCategoryList({ page: 1, limit: 100 }));
  }, [dispatch, id]);

  useEffect(() => {
    if (news?.data) {
      setNewsData({
        title: news.data.title || "",
        description: news.data.description || "",
        url: news.data.url || "",
        type: news.data.type || "",
        news_link: news.data.news_link || "",
        start_date: news.data.start_date || "",
        end_date: news.data.end_date || "",
        category: news.data.category || "",
        project: news.data.project || "",
        country: news.data.country?._id || news.data.country || "",
        state: news.data.state?._id || news.data.state || "",
        city: news.data.city?._id || news.data.city || "",
      });
    }
  }, [news]);

  useEffect(() => {
    if (newsData.country) {
      dispatch(viewStateListPagination({ country: newsData.country }));
    }
  }, [newsData.country, dispatch]);

  useEffect(() => {
    if (!newsData.state) {
      setNewsData((prev) => ({ ...prev, city: "" }));
      return;
    }
    dispatch(viewCityList({ state: newsData.state, country: newsData.country, page: 1, limit: 200 }));
  }, [newsData.state, newsData.country, dispatch]);

  useEffect(() => {
    if (!enumsData?.data?.ProjectStatus) return;
    const projectStatus = Object.values(enumsData.data.ProjectStatus);
    dispatch(getProjectList({ status: projectStatus, page: 1, limit: 500, is_deleted: false }));
  }, [dispatch, enumsData]);

  return (
    <MainLayout>
      <div className="en-wrapper">
        <div className="en-header">
          <div className="en-header-left">
            <div className="en-header-icon">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
              </svg>
            </div>
            <div>
              <h1 className="en-title">Edit News / Article</h1>
              <p className="en-subtitle">Update the details of this article</p>
            </div>
          </div>
          <Link to="/news_and_articles" className="en-view-btn">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
              <polyline points="14 2 14 8 20 8" />
            </svg>
            View News List
          </Link>
        </div>

        <div className="en-nav">
          {sections.map((sec, i) => (
            <button
              key={i}
              className={`en-nav-pill ${activeSection === i ? "en-nav-pill--active" : ""}`}
              onClick={() => setActiveSection(i)}
              type="button"
            >
              <span className="en-nav-num">{String(i + 1).padStart(2, "0")}</span>
              {sec}
            </button>
          ))}
        </div>

        <form className="en-form">
          <div className={`en-section ${activeSection === 0 ? "en-section--visible" : ""}`}>
            <div className="en-section-header">
              <span className="en-section-badge">01</span>
              <h2 className="en-section-title">Basic Information</h2>
            </div>
            <div className="en-grid en-grid-2">
              <div className="en-field">
                <label className="en-label">
                  Title <span className="en-req">*</span>
                </label>
                <input
                  className="en-input"
                  type="text"
                  name="title"
                  value={newsData.title}
                  onChange={handleChange}
                  placeholder="Enter news title"
                  maxLength={EDIT_TITLE_LIMIT}
                />
                <span className="en-char-count">
                  {newsData.title.length}/{EDIT_TITLE_LIMIT}
                </span>
              </div>
              <div className="en-field">
                <label className="en-label">
                  Category <span className="en-req">*</span>
                </label>
                <select
                  className="en-select"
                  name="category"
                  value={newsData.category}
                  onChange={handleChange}
                >
                  <option value="">Select a category</option>
                  {categoryOptions.map((cat) => (
                    <option key={cat} value={cat}>
                      {cat.charAt(0).toUpperCase() + cat.slice(1)}
                    </option>
                  ))}
                </select>
              </div>
              <div className="en-field en-field--full">
                <label className="en-label">
                  Description <span className="en-req">*</span>
                </label>
                <textarea
                  className="en-textarea"
                  name="description"
                  value={newsData.description}
                  onChange={handleChange}
                  placeholder="Write a detailed description..."
                  rows={4}
                />
              </div>
              <div className="en-field">
                <label className="en-label">
                  Select Project <span className="en-optional">(Optional)</span>
                </label>
                <select
                  className="en-select"
                  name="project"
                  value={newsData.project}
                  onChange={handleChange}
                >
                  <option value="">Select a project</option>
                  {Array.isArray(projects?.data) &&
                    projects.data.map((project) => (
                      <option key={project._id} value={project._id}>
                        {project.project_name}
                      </option>
                    ))}
                </select>
              </div>
              <div className="en-field">
                <label className="en-label">
                  News Link <span className="en-optional">(Optional)</span>
                </label>
                <input
                  className="en-input"
                  type="text"
                  name="news_link"
                  value={newsData.news_link}
                  onChange={handleChange}
                  placeholder="https://example.com/article"
                />
              </div>
            </div>
          </div>

          <div className={`en-section ${activeSection === 1 ? "en-section--visible" : ""}`}>
            <div className="en-section-header">
              <span className="en-section-badge">02</span>
              <h2 className="en-section-title">Location & Dates</h2>
            </div>
            <div className="en-grid en-grid-2">
              <div className="en-field">
                <label className="en-label">
                  Country <span className="en-optional">(Optional)</span>
                </label>
                <select
                  className="en-select"
                  name="country"
                  value={newsData.country}
                  onChange={handleChange}
                >
                  <option value="">Select country</option>
                  {Array.isArray(countryList?.data) &&
                    countryList.data.map((country) => (
                      <option key={country._id} value={country._id}>
                        {country.country_name}
                      </option>
                    ))}
                </select>
              </div>
              <div className="en-field">
                <label className="en-label">
                  State <span className="en-optional">(Optional)</span>
                </label>
                <select
                  className={`en-select ${!newsData.country ? "en-select--disabled" : ""}`}
                  name="state"
                  value={newsData.state}
                  onChange={handleChange}
                  disabled={!newsData.country}
                >
                  <option value="">
                    {!newsData.country ? "Select country first" : "Select state"}
                  </option>
                  {Array.isArray(states?.data) &&
                    states.data.map((state) => (
                      <option key={state._id} value={state._id}>
                        {state.state_name}
                      </option>
                    ))}
                </select>
              </div>
              <div className="en-field">
                <label className="en-label">
                  City <span className="en-optional">(Optional)</span>
                </label>
                <select
                  className={`en-select ${!newsData.state ? "en-select--disabled" : ""}`}
                  name="city"
                  value={newsData.city}
                  onChange={handleChange}
                  disabled={!newsData.state}
                >
                  <option value="">
                    {!newsData.state ? "Select state first" : "Select city"}
                  </option>
                  {Array.isArray(cities?.data) &&
                    cities.data.map((city) => (
                      <option key={city._id} value={city._id}>
                        {city.city_name}
                      </option>
                    ))}
                </select>
              </div>
              <div className="en-field" />
              <div className="en-field">
                <label className="en-label">
                  Start Date <span className="en-optional">(Optional)</span>
                </label>
                <input
                  className="en-input"
                  type="date"
                  name="start_date"
                  value={DateToNormal(newsData.start_date)}
                  onChange={handleChange}
                />
              </div>
              <div className="en-field">
                <label className="en-label">
                  End Date <span className="en-optional">(Optional)</span>
                </label>
                <input
                  className="en-input"
                  type="date"
                  name="end_date"
                  value={DateToNormal(newsData.end_date)}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>

          <div className={`en-section ${activeSection === 2 ? "en-section--visible" : ""}`}>
            <div className="en-section-header">
              <span className="en-section-badge">03</span>
              <h2 className="en-section-title">Media & Links</h2>
            </div>
            <div className="en-grid en-grid-2">
              <div className="en-field">
                <label className="en-label">
                  Upload Type <span className="en-optional">(Optional)</span>
                </label>
                <select
                  className="en-select"
                  value={selection}
                  onChange={(e) => setSelection(e.target.value)}
                >
                  <option value="">Select upload type</option>
                  {uploadOptions.map((opt) => (
                    <option key={opt} value={opt}>
                      {opt.toUpperCase()}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {selection === "file" && (
              <div className="en-grid en-grid-2" style={{ marginTop: "20px" }}>
                <div className="en-field">
                  <label className="en-label">Upload Image</label>
                  <input
                    className="en-input"
                    type="file"
                    id="image"
                    disabled={!!newsData.url || uploading.image}
                    onChange={handleFileUpload}
                    accept="image/*"
                  />
                  {uploading.image && (
                    <span className="en-upload-loader">
                      <span className="en-spinner" /> Uploading image...
                    </span>
                  )}
                  {newsData.url && newsData.type === "image" && (
                    <ImageShowerModalGlobal
                      file={newsData.url}
                      state={newsData}
                      setState={setNewsData}
                      keyField="image"
                    />
                  )}
                </div>
                <div className="en-field">
                  <label className="en-label">Upload Video</label>
                  <input
                    className="en-input"
                    type="file"
                    id="video"
                    disabled={!!newsData.url || uploading.video}
                    onChange={handleFileUpload}
                    accept="video/*"
                  />
                  {uploading.video && (
                    <span className="en-upload-loader">
                      <span className="en-spinner" /> Uploading video...
                    </span>
                  )}
                  {newsData.url && newsData.type === "video" && (
                    <ImageShowerModal
                      file={newsData.url}
                      onClick={() => setNewsData((prev) => ({ ...prev, url: "", type: "" }))}
                    />
                  )}
                </div>
              </div>
            )}

            {selection === "url" && (
              <div className="en-grid en-grid-2" style={{ marginTop: "20px" }}>
                <div className="en-field en-field--full">
                  <label className="en-label">Media URL</label>
                  <input
                    className="en-input"
                    type="text"
                    name="url"
                    value={newsData.url}
                    onChange={handleChange}
                    placeholder="https://example.com/image.jpg"
                  />
                </div>
              </div>
            )}
          </div>

          <div className="en-footer">
            <div className="en-footer-nav">
              <button
                type="button"
                className="en-btn en-btn--ghost"
                onClick={() => setActiveSection((s) => Math.max(0, s - 1))}
                disabled={activeSection === 0}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="15 18 9 12 15 6" />
                </svg>
                Back
              </button>
              {activeSection < sections.length - 1 ? (
                <button
                  type="button"
                  className="en-btn en-btn--primary"
                  onClick={() => setActiveSection((s) => Math.min(sections.length - 1, s + 1))}
                >
                  Next
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="9 18 15 12 9 6" />
                  </svg>
                </button>
              ) : (
                <button type="button" onClick={handleSubmit} className="en-btn en-btn--submit">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                  Update Article
                </button>
              )}
            </div>
            <Link to="/news_and_articles" className="en-btn en-btn--cancel">
              Cancel
            </Link>
          </div>
        </form>
      </div>
    </MainLayout>
  );
};

export default EditNews;